import { productOrder } from '@modules/constants-enumerate';

const productOrderDict = productOrder.reduce((acc, product, index) => {
  acc[product] = index;
  return acc;
}, {});
/**
 * @param products {{product: string}[]}
 * @returns {*}
 */
const getSortedProducts = function(products) {
  return products.sort((a, b) => {
    return productOrderDict[a.product] - productOrderDict[b.product];
  });
};

export {
  getSortedProducts
};
